// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SignIn from './SignIn';
import TeamSelection from './TeamSelection';
import TeamPage from './TeamPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Route for the sign-in page */}
        <Route path="/" element={<SignIn />} />
        {/* Route for team selection */}
        <Route path="/select-team" element={<TeamSelection />} />
        {/* Route for team-specific pages */}
        <Route path="/team/:teamId" element={<TeamPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;